import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHeartEmojiSecondary from './svgs/HeartEmojiSecondary.js';
import SvgHeartEmoji from './svgs/HeartEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var heartEmoji = (props => useIcon(SvgHeartEmoji, SvgHeartEmojiSecondary, props));

export { heartEmoji as default };
